import makeStyles from '@material-ui/core/styles/makeStyles';

const useStyle = makeStyles(theme => ({
  errorDialog: {
    minHeight: 500,
    maxHeight: 500,
  },
  errorWrapper: {
    minHeight: 360,
    maxHeight: 360,
  },
  emailInput: {
    '& input:valid + fieldset': {
      borderColor: 'green',
    },
    '& input:invalid + fieldset': {
      borderColor: 'red',
    },
    '& label': {
      color: 'green',
    },
  },
  backDrop: {
    background: 'none',
  },
}));

export default useStyle;
